// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SearchTextField, { SearchTextFieldStyles } from "@insite/content-library/Widgets/OrderHistory/SearchTextField";
import * as React from "react";

export const orderTotalStyles: SearchTextFieldStyles = {};
const styles = orderTotalStyles;

const OrderHistorySearchFieldOrderTotal: React.FunctionComponent<WidgetProps> = () => {
    return (
        <SearchTextField
            testSelector="orderHistory_filterOrderTotal"
            styles={styles}
            parameterField="orderTotal"
            label="Amount"
            inputType="number"
            // XNG-Changes
            placeholder={translate("Amount")}
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderHistorySearchFieldOrderTotal,
    definition: {
        group: "Order History",
        allowedContexts: ["OrderHistoryPage", "VmiOrderHistoryPage"],
        displayName: "Order Total",
    },
};

export default widgetModule;
